'use client'

import { motion } from "framer-motion"
import { Button } from "@/components/ui/button"

export default function MessagesPage() {
  return (
    <div className="min-h-screen bg-white">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="bg-white border-b border-[#171A20]/10 shadow-sm relative"
      >
        <div className="relative py-8 mx-auto max-w-[110rem] px-4 sm:px-6 lg:px-10">
          <div className="flex flex-col items-center justify-center text-center space-y-8 py-24">
            <h1 className="text-4xl md:text-5xl font-bold uppercase text-[#171A20]" style={{ fontFamily: '"Universal Sans Display", -apple-system, Arial, sans-serif', letterSpacing: '0.025em' }}>
              Coming Soon
            </h1>
            <p className="text-xl text-[#5C5E62] max-w-2xl">
              We&apos;re working on something exciting! Our messaging system will be available soon to help you communicate with our team and stay updated on your projects.
            </p>
            <Button
              variant="outline"
              className="border-[#171A20]/10 hover:bg-[#171A20]/5 hover:border-[#171A20]/20 transition-colors"
            >
              Get Notified When It&apos;s Ready
            </Button>
          </div>
        </div>
      </motion.div>
    </div>
  )
} 